var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab_header"},[_vm._m(0),_c('div',{staticClass:"trackingProgress"},[_c('div',{staticClass:"progress",class:{pos : _vm.pos}})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"th_body"},[_c('div',{staticClass:"th_content"},[_c('p',[_vm._v("이용약관 동의")])]),_c('div',{staticClass:"th_content"},[_c('p',[_vm._v("회원정보 입력")])])])
}]

export { render, staticRenderFns }